import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { MyDailyFive } from "scmp-app/components/my-news//my-daily-five";
import { MynewsHeader } from "scmp-app/components/my-news/mynews-header";

export const StyledMynewsHeader = styled(MynewsHeader)`
  margin-block-end: 50px;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 58px;
  }
`;

export const StyledMyDailyFive = styled(MyDailyFive)`
  max-inline-size: 1272px;
  margin-block: 0 56px;
  margin-inline: auto;
  padding-block: 0;
  padding-inline: 16px;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 0;
    padding-block: 0;
    padding-inline: 32px;
  }
`;
